<img
  [src]="izsLogoSrc"
  alt="izs-logo"
  class="izs-logo"
  [ngClass]="{ 'small-logo': isSmallLogo, pointer: !hideTooltip }"
  [ngbTooltip]="hideTooltip ? '' : ('izs.tooltip' | translate)"
/>
